
import { alertsConstants } from '../constants/alertsConstants';

export const alertsActions = {
  renderAlert,
  clearAlert,
  renderAlerts,
  clearAlerts
};
 
export const renderAlert = (type, message) => ({
  type: alertsConstants.RENDER, alertType: type, message: message
});

export const clearAlert = () => ({
  type: alertsConstants.CLEAR, alertType: null, message: null
});

function renderAlerts(type, message){
  return  {type: alertsConstants.RENDER, alertType: type, message: message}
}


function clearAlerts(){
  return { type: alertsConstants.CLEAR, alertType: null, message: null}
}
 




// WEBPACK FOOTER //
// ./src/app/redux/actions/alertsActions.js